export default function () {
    this.fillWorkProfiles()
}
